module.exports = __webpack_public_path__ + "img/oil_spill_activity_splash.37790066.jpg";